"use strict";
var ACC;
ACC.hero = {

    _autoload: [
		"bindHero",
	],

    bindHero: function() {
        $(".hero-banner-container").on("click", function() {
            const screenWidth = window.innerWidth;
            const enableVideo = $(this).data("enablevideo");
            const componentId = $(this).data("componentid");
            const viewNumber = $(this).data("viewnumber");
            const dataUrl = (screenWidth >= 641) ? $(this).data("landscapeurl") : $(this).data("portraiturl");
            const dataName = $(this).data("name");
           
            ACC.gtm.trackPromotionEditorialVideoClickGtmEvent(componentId, viewNumber, enableVideo && dataUrl, dataName );
		});
    },

    resizeVideoAltText: function(desktopAlt, tabletAlt, mobileAlt) {
        const altText = ACC.common.chooseResizeVal(desktopAlt, tabletAlt, mobileAlt);
        document.querySelector('.video__src').setAttribute('aria-label', altText);
    },

    resizeVideoPoster: function(desktopPoster, tabletPoster, mobilePoster) {
        const poster = ACC.common.chooseResizeVal(desktopPoster, tabletPoster, mobilePoster);
        document.querySelector('.video__src').setAttribute('poster', poster);
    },
};
